import { NoAccounts } from "@mui/icons-material";
import { Box, SxProps, Typography } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon";
import React from "react";

interface EmptyStateProps {
  /** O componente de ícone do MUI (ex: NoAccounts) */
  icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  /** Texto principal (variant="subtitle1") */
  title: string;
  /** Texto secundário opcional (variant="body2") */
  description?: string;
  /** Estilos adicionais para o Box container, se necessário */
  sx?: SxProps;
}

/**
 * Componente genérico para exibir um estado "vazio":
 * um ícone + título + descrição centralizados.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon = NoAccounts,
  title,
  description,
  sx = {},
}) => (
  <Box display="flex" flexDirection="column" alignItems="center" py={4} sx={sx}>
    <Icon color="disabled" sx={{ fontSize: 48, mb: 1 }} />
    <Typography variant="subtitle1" color="textSecondary">
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="textSecondary">
        {description}
      </Typography>
    )}
  </Box>
);

export default EmptyState;
